import Utils from '@/common/utils/utils';
import { CONTRACT_STATUS, FIELDS_VALIDATE, YEAR } from '@/common/constant/NormalContractManagementConstant';
import moment from 'moment';
import trI18n from '@/common/utils/trI18n';

const handleValidate = (inputvalue, field) => {
    if (field === FIELDS_VALIDATE.GENERAL_USER.TITLE) {
        return validateBasicSetting(inputvalue);
    }

    return validateAdvancedSetting(inputvalue, field);
};

const validateBasicSetting = inputvalue => {
    if (Utils.isEmpty(inputvalue) || Utils.isEmptyString(inputvalue)) {
        return trI18n('COMMSG014');
    }

    if (!Utils.isNumber(inputvalue) || Number(inputvalue) <= 0) {
        return trI18n('MSG-CM-WRONG-NUMBER-FORMAT').replace(
            '{{min_value}}',
            `${FIELDS_VALIDATE.GENERAL_USER.RULES.MIN_VALUE}`
        );
    }

    if (inputvalue.length > FIELDS_VALIDATE.GENERAL_USER.RULES.MAX_LENGTH) {
        return trI18n('MSG-CM-OVER-MAXLENGTH').replace(
            '{{maxLength}}',
            `${FIELDS_VALIDATE.GENERAL_USER.RULES.MAX_LENGTH}`
        );
    }

    return '';
};

const validateAdvancedSetting = (inputvalue, field) => {
    if (inputvalue.length > FIELDS_VALIDATE.OTHER_RULES.MAX_LENGTH) {
        return trI18n('MSG-CM-OVER-MAXLENGTH').replace(
            '{{maxLength}}',
            `${FIELDS_VALIDATE.OTHER_RULES.MAX_LENGTH}`
        );
    }

    if (!Utils.isNumber(inputvalue)) {
        return trI18n('MSG-CM-WRONG-NUMBER-FORMAT').replace(
            '{{min_value}}',
            `${FIELDS_VALIDATE.OTHER_RULES.MIN_VALUE}`
        );
    }

    return '';
};

const calcBasePriceByVersionUpdate = (basicSetting, advancedSetting, versionData) => {
    return totalBasePrice(
        Number(versionData?.moduleSetting?.basicCharge) || 0,
        Number(basicSetting?.numOfGeneralUser.quantity.update) || 0,
        Number(versionData?.moduleSetting?.generalUserFee) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalTickets?.price) || 0,
        Number(advancedSetting?.numOfTicket.quantity.update) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalKnowledge?.price) || 0,
        Number(advancedSetting?.numOfTicketKnowledge.quantity.update) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalStorages?.price) || 0,
        Number(advancedSetting?.numOfStorage.quantity.update) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalQACounter?.price) || 0,
        Number(advancedSetting?.numberOfQACounters.quantity.update) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalSupportedCounter?.price) || 0,
        Number(advancedSetting?.numberOfSupportedCounters.quantity.update) || 0
    );
};

const calcBasePriceByVersionCurrent = (additionalUpgradeSetting, versionData) => {
    return totalBasePrice(
        Number(versionData?.moduleSetting?.basicCharge) || 0,
        Number(additionalUpgradeSetting?.maxNumOfGeneralUser) || 0,
        Number(versionData?.moduleSetting?.generalUserFee) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalTickets?.price) || 0,
        Number(additionalUpgradeSetting?.numOfSetTicket) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalKnowledge?.price) || 0,
        Number(additionalUpgradeSetting?.numOfSetKnowledge) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalStorages?.price) || 0,
        Number(additionalUpgradeSetting?.numOfSetStorage) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalQACounter?.price) || 0,
        Number(additionalUpgradeSetting?.numOfSetQACounter) || 0,
        Number(versionData?.moduleSetting?.numberOfAdditionalSupportedCounter?.price) || 0,
        Number(additionalUpgradeSetting?.numOfSetSupportCounter) || 0
    );
}

const totalBasePrice = (
    priceOfBasicCharge,
    numberOfGeneralUser,
    priceOfNumberOfGeneralUser,
    priceOfNumberSetTicket,
    numberSetTicket,
    priceOfNumberSetTicketKnowledge,
    numberSetTicketKnowledge,
    priceOfNumberSetStorage,
    numberSetStorage,
    priceOfNumberSetQACount,
    numberSetQACount,
    priceOfNumberSetSupportCounter,
    numberSetSupportCounter
) => {
    const total = priceOfBasicCharge +
        numberOfGeneralUser * priceOfNumberOfGeneralUser +
        numberSetTicket * priceOfNumberSetTicket +
        numberSetTicketKnowledge * priceOfNumberSetTicketKnowledge +
        numberSetStorage * priceOfNumberSetStorage +
        numberSetQACount * priceOfNumberSetQACount +
        numberSetSupportCounter * priceOfNumberSetSupportCounter;
        
    return Math.round(total);
}


const caculatorTotal = (basicSetting, advancedSetting, versionUpdate, paymentCycle, increaseRate, paymentCycleOfCurrent, contractStatus) => {
    const rate = !Utils.isEmpty(increaseRate) ? Number(increaseRate) : 0;

    return contractStatus == CONTRACT_STATUS.ACTIVE ? 
       calcPriceToTalOfContract(paymentCycleOfCurrent, basicSetting, advancedSetting, versionUpdate, rate) : 
       calcPriceToTalOfContract(paymentCycle.code, basicSetting, advancedSetting, versionUpdate, rate);
};

const calcPriceToTalOfContract = (paymentCycle, basicSetting, advancedSetting, versionUpdate, rate) => {
    return paymentCycle === YEAR.CODE ? 
            priceByYear(basicSetting, advancedSetting, versionUpdate) : 
            priceByMonth(basicSetting, advancedSetting, versionUpdate, rate);
}

const discountActiveToActive = (
    startDate, 
    endDate, 
    paymentCycleOfCurrent, 
    increaseRate, 
    basicSetting, 
    advancedSetting, 
    versionUpdate,
    versionCurrent,
    additionalUpgradeSetting
) => {
    const today = moment(new Date());
    const formatStartDate = moment(new Date(startDate));
    const formatEndDate = moment(new Date(endDate));
    const totalDaysOfYearOrMonthUpdate = formatEndDate.diff(formatStartDate, 'days') + 1;
    const numberOfDaysOfUse = today.diff(formatStartDate, 'days') + 1;
    const unusedDays = totalDaysOfYearOrMonthUpdate <= numberOfDaysOfUse ? 0 : formatEndDate.diff(today, 'days') + 1;

    if (paymentCycleOfCurrent === YEAR.CODE) {
        const totalPriceOfCurrentVersion = priceByYear(basicSetting, advancedSetting, versionCurrent, additionalUpgradeSetting, false);
        const totalPriceOfUpdatedVersion = priceByYear(basicSetting, advancedSetting, versionUpdate);
        const totalDiscountPriceByYear = (numberOfDaysOfUse/totalDaysOfYearOrMonthUpdate) * totalPriceOfUpdatedVersion + (unusedDays/totalDaysOfYearOrMonthUpdate) * totalPriceOfCurrentVersion;

        return Math.round(totalDiscountPriceByYear);
    }

    const totalPriceOfCurrentVersionByMonth = priceByMonth(basicSetting, advancedSetting, versionCurrent, increaseRate, additionalUpgradeSetting, false);
    const totalPriceOfUpdatedVersionByMonth = priceByMonth(basicSetting, advancedSetting, versionUpdate, increaseRate);
    const totalDaysOfMonthUpdate = formatStartDate.daysInMonth();
    const totalDiscountPriceByMonth = numberOfDaysOfUse/totalDaysOfMonthUpdate * totalPriceOfUpdatedVersionByMonth + unusedDays/totalDaysOfMonthUpdate * totalPriceOfCurrentVersionByMonth;

    return Math.round(totalDiscountPriceByMonth);
}

const caculatorDiscount = (basicSetting, advancedSetting, versionUpdate, increaseRate, contractDetail, versionCurrent) => {
    return contractDetail.contractStatus == CONTRACT_STATUS.ACTIVE ? discountActiveToActive(
        contractDetail.startDate, 
        contractDetail.billEndDate, 
        contractDetail?.currentPaymentCycle, 
        increaseRate,
        basicSetting, 
        advancedSetting, 
        versionUpdate,
        versionCurrent,
        contractDetail.additionalUpgradeSetting
    ) : 0;
};

const priceByMonth = (basicSetting, advancedSetting, versionData, increaseRate, additionalUpgradeSetting = {}, isPriceForVersionUpdate = true) => {
    let additionalPrice = calcBasePriceByVersionUpdate(basicSetting, advancedSetting, versionData) * Number(increaseRate) / 100;
    let totalPriceByMonth = Math.round(calcBasePriceByVersionUpdate(basicSetting, advancedSetting, versionData) + additionalPrice);
    if (!isPriceForVersionUpdate) {
        additionalPrice = calcBasePriceByVersionCurrent(additionalUpgradeSetting, versionData) * Number(increaseRate) / 100;
        totalPriceByMonth = Math.round(calcBasePriceByVersionCurrent(additionalUpgradeSetting, versionData) + additionalPrice);
    }

    return totalPriceByMonth <= 0 ? 0 : totalPriceByMonth;
}

const priceByYear = (basicSetting, advancedSetting, versionUpdate, additionalUpgradeSetting = {}, isPriceForVersionUpdate = true) => {
    const totalPriceByYear = isPriceForVersionUpdate ? calcBasePriceByVersionUpdate(basicSetting, advancedSetting, versionUpdate) * 12 : calcBasePriceByVersionCurrent(additionalUpgradeSetting, versionUpdate) * 12;
    return totalPriceByYear <= 0 ? 0 : totalPriceByYear;
}

export { handleValidate, caculatorTotal, caculatorDiscount };
